import transactionsMock from "../../data/mocks/transactions.json";
/**
 * @internal
 * Private implementation for getting transactions (mock).
 *
 * @remarks
 * - Currently returns mock data.
 * - Planned upstream: Consolidated DeFi SDK transactions endpoint
 *   (e.g., `accountApi.accountV1Transactions`) once exposed in the SDK.
 */
export async function _getTransactions(..._args) {
    return transactionsMock;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNhY3Rpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL21haW4vbW9kdWxlcy9kZWZpL3RyYW5zYWN0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLGdCQUFnQixNQUFNLG9DQUFvQyxDQUFDO0FBRWxFOzs7Ozs7OztHQVFHO0FBQ0gsTUFBTSxDQUFDLEtBQUssVUFBVSxnQkFBZ0IsQ0FBQyxHQUFHLEtBQWdCO0lBQ3hELE9BQU8sZ0JBQWdCLENBQUM7QUFDMUIsQ0FBQyJ9